export default __webpack_public_path__ + "static/media/grafema_ciceco_10.3ccd0875.jpg";